import { createFileRoute } from "@tanstack/react-router";
import AdminScriptsPage from "@/admin/pages/scripts";

export const Route = createFileRoute("/admin/scripts")({
  component: AdminScriptsPage,
});
